import { Block, FullBlock, User } from 'model';
import { BaseApi } from './BaseAPI';

const baseURL = 'block/';
export const BlockApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		// get all blocks for a user
		getUserBlocks: builder.query<FullBlock[], void>({
			query: () => ({
				url: `${baseURL}all/`
			}),
			providesTags: result => (!result ? [] : result?.map(block => ({ type: 'Block', id: block._id })))
		}),
		getBlockForUserByUserToBlock: builder.query<Block, User['_id']>({
			query: userToBlock => ({
				url: `${baseURL}user/${userToBlock}`
			}),
			providesTags: (...args) => [{ type: 'Block', id: args[2] }]
		}),
		blockUser: builder.mutation<Block, { userToBlock: User['_id'] }>({
			query: ({ userToBlock }) => ({
				url: `${baseURL}create`,
				method: 'PUT',
				body: { userToBlock }
			}),
			invalidatesTags: [{ type: 'Block' }]
		}),
		unBlockUser: builder.mutation<Block, { userToBlock: User['_id'] }>({
			query: ({ userToBlock }) => ({
				url: `${baseURL}delete`,
				method: 'DELETE',
				body: { userToBlock }
			}),

			invalidatesTags: [{ type: 'Block' }]
		}),
		updateBlockStatusForUserByUserToBlock: builder.mutation<Block, { userToBlock: User['_id']; status: string }>({
			query: ({ userToBlock, status }) => ({
				url: `${baseURL}update`,
				method: 'PUT',
				body: { userToBlock, status }
			}),
			invalidatesTags: (...args) => [{ type: 'Block', id: args[2].userToBlock }]
		})
	})
});

export const {
	useBlockUserMutation,
	useUnBlockUserMutation,
	useGetUserBlocksQuery,
	useGetBlockForUserByUserToBlockQuery,
	useUpdateBlockStatusForUserByUserToBlockMutation
} = BlockApi;
